import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';

import { constructPagePath } from 'utils/localeRouteGuide';
import { locale } from 'utils/locale';

import BuyBar from 'components/BuyBar/BuyBar';
import localize from 'components/Localize/Localize';
import FooterNav from 'components/FooterNav/FooterNav';
import NotificationContainer from 'components/NotificationContainer/NotificationContainer';
import SubNav from 'components/SubNav/SubNav';

import header from 'components/Header/Header.css';
import translations from './translations';

class ProductPageContainer extends React.Component {
  getProductTranslationContent() {
    return this.props.t[this.props.productType];
  }

  getCurrentIndex() {
    const links = this.getProductTranslationContent().links;
    const {location} = this.context.router.route;

    return links.findIndex((item) => constructPagePath(this.props.locale, item.link).replace(/\/$/, ``) === location.pathname.replace(/\/$/, ``));
  }

  buyPage() {
    const mattressTypes = [ `mattressEssential`, `mattress`, `mattressPremium` ];

    return mattressTypes.indexOf(this.props.productType) >= 0 && locale(this.props.locale).isNA();
  }

  renderSubnav() {
    if (!this.props.subNav) {
      return null;
    }

    return (
      <SubNav
        locale={this.props.locale}
        productContent={this.getProductTranslationContent()}
        selectedLinkIndex={this.getCurrentIndex()}
      />
    );
  }

  renderBuyBar() {
    if (!this.props.buyBar) {
      return null;
    }

    return (
      <BuyBar
        buyPage={this.buyPage()}
        productKey={this.props.productType}
        showQuantitySelector={this.props.showQuantitySelector}
        showRatings={this.props.showRatings}
      />
    );
  }

  renderFooterNav() {
    if (!this.props.footerNav) {
      return null;
    }

    return (
      <FooterNav
        links={this.getProductTranslationContent().links}
        selectedLinkIndex={this.getCurrentIndex()}
      />
    );
  }

  render() {
    const headerClass = classNames({
      [header[`site-padding-top`]]: !this.props.subNav && !this.props.buyBar,
      [header[`site-padding-top--with-subnav`]]: this.props.subNav,
      [header[`site-padding-top--with-buybar`]]: this.props.buyBar,
    });

    return (
      <div>
        {this.renderSubnav()}
        {this.renderBuyBar()}
        <div className={headerClass}>
          <NotificationContainer />
          {this.props.children}
        </div>
        {this.renderFooterNav()}
      </div>
    );
  }
}

ProductPageContainer.propTypes = {
  buyBar: PropTypes.bool,
  children: PropTypes.node,
  footerNav: PropTypes.bool,
  locale: PropTypes.string.isRequired,
  showQuantitySelector: PropTypes.bool,
  showRatings: PropTypes.bool,
  subNav: PropTypes.bool,
  t: PropTypes.objectOf(PropTypes.shape({
    links: PropTypes.arrayOf(PropTypes.shape({
      link: PropTypes.string.isRequired,
      linkText: PropTypes.string.isRequired,
    })),
    title: PropTypes.string.isRequired,
  })),
};

ProductPageContainer.contextTypes = {
  router: PropTypes.object,
};

export default localize(ProductPageContainer, translations);
